module.exports = __webpack_public_path__ + "./docs/img/big-icon-constructor.4dc69a50221ece281bfb65420c8fa677.svg";